document.addEventListener('DOMContentLoaded', () => {
  const labels = {
    collection: ".bundle__collection-label",
    filter: ".bundle__container-header",
  };

  const selectors = {
    variant: ".bundle__variant-item, .variant-features",
  }

  function collectionChange() {
    document.querySelectorAll(labels.collection).forEach((el) => {
      // ensure the data attribute name matches (data-collection -> el.dataset.collection)
      let collectionId = el.dataset.collection;
      let labelId = el.dataset.labelId

      el.addEventListener("click", () => {
        // dispatch the payload under detail; use collectionId 
        document.dispatchEvent(new CustomEvent("custom:collectionChanged", {
          detail: { id: collectionId, label: labelId }
        }));
      });
    });
  }

  document.addEventListener("custom:collectionChanged", (e) => {
    let collection =  e.detail.id
    let label =  e.detail.label

    updateFilterLabels(collection, label)
  });

   document.addEventListener("custom:variantChanged", e => {
    let id = e.detail.product.variant.id
    let block = e.detail.product.variant.block

    updateVariantImage(id, block) 
  })

  collectionChange();

  function updateFilterLabels(collectionId, labelId) {
    document.querySelectorAll(labels.filter).forEach((el) => {

      let id = el.dataset.id
      let label = el.dataset.labelId

      if(label == labelId){
         if (collectionId == id) {    
          showElement(el)    
          updateDisplayedOptions(el)
        } else    
        {      
          hideElement(el)  
        }
      }
    })
  }

  function showElement(el) {
    el.classList.remove("hide");
  }  

  function hideElement(el) {
    el.classList.add("hide");
  }

  function updateDisplayedOptions(el) {
    let position =  el.dataset.forloop
    let parent = el.parentElement.parentElement

    let data = {
      product: el.dataset.product,      
      options: parent.querySelectorAll(".bundle__variant-grid"),
      checkboxes: parent.querySelectorAll(".bundle__variant-checkbox")
    }

    if (position == 1) {
       document.dispatchEvent(new CustomEvent("custom:headerChanged", {         
        detail: { header: data }       
      }));
    }
    
  }

  function updateVariantImage(variantId, variantBlock) {
    // console.log(variantId, variantBlock)

    document.querySelectorAll(selectors.variant).forEach((variant) => {
 
      let id = variant.dataset.variant
      let featuresId = variant.dataset.featuresId
      let block = variant.dataset.blockId

      if(block == variantBlock){
        if (id == variantId || featuresId == variantId) {
         showElement(variant)    
        } else    
        {      
          hideElement(variant)  
        }
      }
    })
  }

});